var map = {
	"./modules/about-us/about-us.module": "./src/app/modules/about-us/about-us.module.ts",
	"./modules/activities/activities.module": "./src/app/modules/activities/activities.module.ts",
	"./modules/alumni/alumni.module": "./src/app/modules/alumni/alumni.module.ts",
	"./modules/blog/blog.module": "./src/app/modules/blog/blog.module.ts",
	"./modules/calender/calender.module": "./src/app/modules/calender/calender.module.ts",
	"./modules/course/course.module": "./src/app/modules/course/course.module.ts",
	"./modules/e-content/e-content.module": "./src/app/modules/e-content/e-content.module.ts",
	"./modules/faculty/faculty.module": "./src/app/modules/faculty/faculty.module.ts",
	"./modules/gallery/gallery.module": "./src/app/modules/gallery/gallery.module.ts",
	"./modules/important/important.module": "./src/app/modules/important/important.module.ts",
	"./modules/infrastructure/infrastructure.module": "./src/app/modules/infrastructure/infrastructure.module.ts",
	"./modules/iqac/iqac.module": "./src/app/modules/iqac/iqac.module.ts",
	"./modules/landing-page/landing-page.module": "./src/app/modules/landing-page/landing-page.module.ts",
	"./modules/media/media.module": "./src/app/modules/media/media.module.ts",
	"./modules/menu-detail/menu-detail.module": "./src/app/modules/menu-detail/menu-detail.module.ts",
	"./modules/naac/naac.module": "./src/app/modules/naac/naac.module.ts",
	"./modules/research/research.module": "./src/app/modules/research/research.module.ts",
	"./modules/student-corner/student-corner.module": "./src/app/modules/student-corner/student-corner.module.ts",
	"./modules/ugc-compliance/ugc-compliance.module": "./src/app/modules/ugc-compliance/ugc-compliance.module.ts",
	"./modules/wp-content/wp-content.module": "./src/app/modules/wp-content/wp-content.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;